import Option from "@/models/helpers/Option";

export const projectPolicies = [
    {
        "Name": "ProviderManagementPolicy.Create",
        "Roles": "1AnvAdmin"
    },
    {
        "Name": "ProviderManagementPolicy.Edit",
        "Roles": "1AnvAdmin"
    },
    {
        "Name": "ProviderManagementPolicy.Delete",
        "Roles": "1AnvAdmin"
    },
    {
        "Name": "ProviderManagementPolicy.CompanyWorker.Read",
        "Roles": "1AnvAdmin"
    },
    {
        "Name": "Setting.Navigation.Show",
        "Roles": "1AnvAdmin"
    }
];

export const defaultSpaceAroundTableOnPage = 230;

export const checkboxColumnConfig = {
    id: "checkColumn",
    hideable: false,
    draggable: true,
    resizable: false,
    minWidth: 64,
    width: 64
};

export const chunkSize = 1024 * 1024 * 16; //16MiB

export const isDev = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && typeof console !== 'undefined'

export const baseURL = isDev
    ? "https://localhost:5049"
    : window.location.origin;

